import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'

import pwa_icon from '../../assets/common/pwa_icon.webp'
import pwa_step_1 from '../../assets/common/pwa_step_1.webp'
import useTranslateImage from '../../hooks/useTranslateImage'
import closeModal from '../../utils/closeModal'
import Icon from '../icon'
import Modal from './modal'

const PwaDownloadStepsModal = () => {
  const modal = useModal()
  const { t } = useTranslation('downloadPwa')
  const translateImage = useTranslateImage()

  return (
    <Modal id="pwa-download-steps-modal" containerStyle="px-3.5 py-[30px]">
      <button
        className="flex absolute right-[15px] top-5"
        onClick={() => closeModal(modal)}>
        <Icon id="close" width="15" height="15" className="fill-txt" />
      </button>
      <h3 className="font-black text-xl text-txt text-center mb-6">
        {t('quick-access')}
      </h3>
      <div className="flx-ctr" style={{ marginBottom: 16 }}>
        <img
          src={pwa_icon}
          style={{ minWidth: 50, width: 50, marginRight: 12 }}
          alt="PWA"
        />
        <p className="text-[15px] text-txt">{t('add-icon')}</p>
      </div>
      <p className="text-[15px] text-txt" style={{ marginBottom: 12 }}>
        {t('step-1')}
      </p>
      <img
        src={pwa_step_1}
        style={{ width: '100%', marginBottom: 16 }}
        alt="PWA Step 1"
      />
      <p className="text-[15px] text-txt" style={{ marginBottom: 12 }}>
        {t('step-2')}
      </p>
      <img
        src={translateImage('pwa-step-2')}
        style={{ width: '100%', marginBottom: 16 }}
        alt="PWA Step 2"
      />
    </Modal>
  )
}

export default NiceModal.create(PwaDownloadStepsModal)
